import { initXMLhttp } from './helpers';

export const api = (method, url, options = {}) => {
	const { payload, headers, allowRejects = true } = options;

	return new Promise((resolve, reject) => {
		const http = initXMLhttp();

		http.open(method, url);
		http.onreadystatechange = function (resp) {
			// The operation is complete and success.
			if (this.readyState == 4) {
				if (allowRejects) {
					if (this.status == 200) {
						resolve(http);
					} else {
						console.error('api.js: rejecting the api');
						reject(http);
					}
				} else {
					resolve(http);
				}
			}
		};

		if (headers) {
			Object.keys(headers).map((header) => {
				http.setRequestHeader(header, headers[header]);
			});
		}
		http.setRequestHeader('Content-type', 'application/json');
		payload ? http.send(payload) : http.send();
	});
};

export const downloadAPI = (method, url, options) => {
	const { async, payload, headers, responseType } = options;

	return new Promise((resolve, reject) => {
		const http = initXMLhttp();

		http.open(method, url, async);
		if (responseType) {
			http.responseType = responseType;
		}
		http.setRequestHeader('Content-type', 'application/json');
		http.onreadystatechange = function (resp) {
			if (this.readyState == 4 && this.status == 200) {
				resolve(http);
			}
		};
		if (headers) {
			Object.keys(headers).map((header) => {
				http.setRequestHeader(header, headers[header]);
			});
		}
		payload ? http.send(payload) : http.send();
	});
};
